import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of, from } from 'rxjs';
import { map, mergeMap, catchError } from 'rxjs/operators';
import { PaymentService } from 'app/core/services/payment.service';
import { ProjectService } from 'app/core/services/project.service';
import * as PricingActions from './pricing.actions';

@Injectable()
export class PricingEffects {
    loadPricingInfo$ = createEffect(() =>
        this.actions$.pipe(
            ofType(PricingActions.loadPricingInfo),
            mergeMap(() =>
                this.paymentService.getDeveloperPlansInfo().pipe(
                    map((pricingInfo) =>
                        PricingActions.loadPricingInfoSuccess({ pricingInfo })
                    ),
                    catchError((error) =>
                        of(PricingActions.loadPricingInfoFailure({ error: error.message }))
                    )
                )
            )
        )
    );

    setPlan$ = createEffect(() =>
        this.actions$.pipe(
            ofType(PricingActions.setPlan),
            mergeMap(({ planId }) =>
                from(this.projectService.setDeveloperPlan(planId)).pipe(
                    map(() => PricingActions.setPlanSuccess({ planId })),
                    catchError((error) =>
                        of(PricingActions.setPlanFailure({ error: error.message }))
                    )
                )
            )
        )
    );

    setPlanSuccess$ = createEffect(() =>
        this.actions$.pipe(
            ofType(PricingActions.setPlanSuccess),
            map(() => PricingActions.loadPricingInfo())
        )
    );

    constructor(
        private actions$: Actions,
        private paymentService: PaymentService,
        private projectService: ProjectService
    ) { }
} 